import styled from "styled-components";

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 60px;
  background: #e5e5e5;
`;

Wrap.Body = styled.div`
  display: flex;
`;
Wrap.Content = styled.div`
  flex: 3;
`;

Wrap.Contact = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #e6e9ec;
  box-shadow: 0px 10px 30px rgba(13, 38, 59, 0.05);
  border-radius: 3px;
  padding: 30px;
  margin-bottom: 30px;
`;

Wrap.ChangePassword = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #e6e9ec;
  box-shadow: 0px 10px 30px rgba(13, 38, 59, 0.05);
  border-radius: 3px;
  padding: 30px;
`;
Wrap.ContentTitle = styled.h2`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #0d263b;
  margin-bottom: 45px;
`;
Wrap.Items = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 40px;
`;

// Wrap.Item = styled.div`

// `

Wrap.Input = styled.input`
  width: 100%;
  border: none;
  border-bottom: 2px solid #e6e9ec;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #696969;
  padding-bottom: 8px;
  margin-left: ${({ mr }) => (mr === "true" ? "30px" : "")};
`;
Wrap.TextArea = styled.textarea`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #696969;
  border: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #696969;
  outline: none;
  margin-bottom: 30px;
  border-bottom: 2px solid #e6e9ec;
`;

Wrap.Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 55px;
  background: #0061df;
  border-radius: 3px;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  line-height: 17px;
  text-transform: uppercase;
  color: #ffffff;
`;
Wrap.Title = styled.div`
  h1 {
    font-weight: 600;
    font-size: 30px;
    line-height: 15px;
    color: #0d263b;
  }
  span {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #696969;
  }
  margin-bottom: 60px;
`;

Wrap.Img = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  flex: 1;
  max-width: 330px;
  height: fit-content;
  margin-left: 30px;
  border: 1px solid #e6e9ec;
  box-shadow: 0px 10px 30px rgba(13, 38, 59, 0.05);
  border-radius: 3px;
  padding: 30px;
  img {
    min-width: 269px;
    min-height: 320px;
    border-radius: 3px;
  }
  h2 {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #0d263b;
    margin-bottom: 20px;
  }
`;

Wrap.Upload = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 55px;
  width: 100%;
  background: #ffffff;
  border: 1px solid #0061df;
  box-sizing: border-box;
  border-radius: 3px;
  font-weight: 600;
  font-size: 13px;
  line-height: 17px;
  text-transform: uppercase;
  color: #0061df;
  margin-top: 20px;
  cursor: pointer;
`;
